import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VMain,{staticClass:"app-content"},[_c(VContainer,{attrs:{"fluid":""}},[_vm._t("default",function(){return [_c('router-view',{key:_vm.$route.fullPath})]})],2),_vm._v(" "),_c('panels')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }